import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const About = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className={`min-h-screen py-16 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>  
      <div className="max-w-5xl mx-auto px-4">  
        <div className={`p-8 rounded-lg ${isDark ? 'bg-gray-800' : 'bg-white border border-gray-200'}`}>  
          {/* العنوان */}
          <div className="text-center mb-10">
            <h1 className={`text-3xl md:text-4xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>منصة <span className="text-primary">دوز</span> التعليمية</h1>
          </div>

          {/* من نحن */}
          <div className="mb-8">
            <h2 className={`text-2xl font-bold mb-3 text-primary-600 dark:text-primary-400`}>من نحن؟</h2>
            <p className={`text-lg ${isDark ? 'text-white' : 'text-gray-600'}`}> 
              دوز التعليمية للتدريب الالكتروني، يُقدم المحتوى التعليمي في دوز بشكل سهل وممتع بجودة عالية.
            </p>
          </div>

          <div className={`w-full h-px my-8 ${isDark ? 'bg-gray-700/50' : 'bg-gray-100'}`} />

          {/* الرؤية والرسالة */}
          <div className="space-y-8 mb-8">
            <div>
              <h2 className={`text-2xl font-bold mb-3 text-primary-600 dark:text-primary-400`}>رؤيتنا:</h2>
              <p className={`text-lg ${isDark ? 'text-white' : 'text-gray-600'}`}> 
              متدرب متميز في بيئة فاعلة و تدريب إبداعي منافس.
              </p>
            </div>

            <div>
              <h2 className={`text-2xl font-bold mb-3 text-primary-600 dark:text-primary-400`}>رسالتنا:</h2>
              <p className={`text-lg ${isDark ? 'text-white' : 'text-gray-600'}`}> 
              تقديم تدريب متميز يواكب التوجهات في ضوء السياسات التعليمية للمملكة في بيئة تعليمية جاذبة وآمنة ترتقي بالمهارات والقدرات وتشجع على الإبداع.</p>
            </div>
          </div>

          <div className={`w-full h-px my-8 ${isDark ? 'bg-gray-700/50' : 'bg-gray-100'}`} />

          {/* القيم */}
          <div>
            <h2 className={`text-2xl font-bold mb-3 text-primary-600 dark:text-primary-400`}>قيمنا:</h2>
            <p className={`text-lg ${isDark ? 'text-white' : 'text-gray-600'}`}> 
            الجودة، الشمولية، التميز .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
